import React, { useState } from 'react'
import { Button, Icon, Modal, Header, Input } from 'semantic-ui-react'
import { pathString } from '../../utils/helpers'
import { storageAPI } from '../../utils/api'
import BreadCrumbs from '../shared/BreadCrumbs'
import { observer, useStore } from '../../stores'
import { useTranslation } from 'react-i18next'
export interface NewFolderState {
  modalOpen: boolean
  newFolderName: string
}

const NewFolder = observer(() => {
  const { fileStore } = useStore()
  const { t } = useTranslation()

  const [modalOpen, setModalOpen] = useState(false)
  const [newFolderName, setNewFolderName] = useState<string>('')

  const handleModalOpen = () => {
    setModalOpen(true)
    setNewFolderName('')
  }

  const handleModalClose = () => setModalOpen(false)

  const handleFolderNameChange = (event: any) => {
    setNewFolderName(event.target.value)
  }

  const validateFolderName = (): boolean => {
    const name = newFolderName
    // TODO: add more sophisticated validations here
    const rules = [!name.includes('/'), name.length]

    const passed = rules.every((rule) => !!rule)
    if (passed) {
      return true
    } else {
      // TODO: use prettier alerts.
      alert('Folder Name Not Allowed.')
      return false
    }
  }

  const createNewFolder = async () => {
    if (validateFolderName()) {
      const currentPath = pathString(fileStore.path)
      // TODO: the trailing slash is too important. move to API side and add checks.
      const newFolder = currentPath + `${newFolderName}/`
      console.warn('creating folder :', { newFolder })

      await storageAPI.createFolder(newFolder)
      fileStore.fetch(true)
      handleModalClose()
    }
  }

  const handleEnterPress = ({ key }: any) => {
    key === 'Enter' && createNewFolder()
  }

  return (
    <Modal
      trigger={
        <Button
          basic
          size="big"
          onClick={handleModalOpen}
          color="yellow"
          // animated="fade"
          // style={{ marginTop: '-6px' }}
        >
          {/* <Button.Content hidden>new folder</Button.Content> */}
          <Button.Content visible>
            {/* <Icon name="plus" /> */}
            <Icon name="folder open" />
            {t('newFolder')}
          </Button.Content>
        </Button>
      }
      open={modalOpen}
      onClose={handleModalClose}
      closeIcon
      size="small"
    >
      <Header icon="folder open" content={t('newFolder')} />
      <Modal.Content>
        <p>{t('newFolderPath')}:</p>
        <BreadCrumbs clickable={false} size="huge" />
        <div
          style={{
            position: 'absolute',
            display: 'inline-block',
            marginTop: '-5px',
            marginLeft: '5px',
          }}
        >
          <Input
            placeholder={t('newFolderName')}
            value={newFolderName}
            onKeyPress={handleEnterPress}
            onChange={handleFolderNameChange}
          />
        </div>
      </Modal.Content>
      <Modal.Actions>
        <Button color="yellow" basic onClick={handleModalClose}>
          <Icon name="remove" /> {t('cancel')}
        </Button>
        <Button color="yellow" onClick={createNewFolder}>
          <Icon name="checkmark" /> {t('confirm')}
        </Button>
      </Modal.Actions>
    </Modal>
  )
})

export default NewFolder
